import { render, staticRenderFns } from "./ContextExternal.vue?vue&type=template&id=89ec2f12"
import script from "./ContextExternal.vue?vue&type=script&lang=js"
export * from "./ContextExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports